// extracted by mini-css-extract-plugin
module.exports = {"BladeContent":"📚4-7-0MFM5W"};